import axios from "axios";

const referenceSourceExploreUrl = `/api/v1/reference_sources_explore`;
const fetchCrosswalks = (id, page = 1, per_page = 10, in_or_out) =>
  axios.get(
    `${referenceSourceExploreUrl}/${id}/crosswalks?page=${page}&per_page=${per_page}&in_or_out=${in_or_out}`
  );

const deleteCrosswalks = id =>
  axios.delete(`/api/v1/reference_sources_explore/1/crosswalks/${id}`);

const createCrosswalk = (id, payload) =>
  axios.post(`${referenceSourceExploreUrl}/${id}/crosswalks`, {
    crosswalk: payload,
  });

const showCrosswalk = (id, crosswalkId) =>
  axios.get(`${referenceSourceExploreUrl}/${id}/crosswalks/${crosswalkId}`);

const fetchCdes = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${referenceSourceExploreUrl}/${id}/cde_definitions`, {
    params: { page, per_page, search },
  });

const associateCdes = (id, payload) =>
  axios.post(`${referenceSourceExploreUrl}/${id}/cde_definitions/associate`, {
    cde_definition: payload,
  });

const fetchDomains = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${referenceSourceExploreUrl}/${id}/domains`, {
    params: { page, per_page, search },
  });

const associateDomains = (id, payload) =>
  axios.post(`${referenceSourceExploreUrl}/${id}/domains/associate`, {
    domain: payload,
  });

const fetchDataSources = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${referenceSourceExploreUrl}/${id}/data_sources`, {
    params: { page, per_page, search },
  });

const associateDataSources = (id, payload) =>
  axios.post(`${referenceSourceExploreUrl}/${id}/data_sources/associate`, {
    data_sources: payload,
  });

const fetchBusinessTerms = (id, page = 1, per_page = 10, search = "") =>
  axios.get(`${referenceSourceExploreUrl}/${id}/business_terms`, {
    params: { page, per_page, search },
  });

const associateBusinessTerms = (id, payload) =>
  axios.post(`${referenceSourceExploreUrl}/${id}/business_terms/associate`, {
    business_term: payload,
  });
const referenceSourcesExploreApi = {
  fetchCrosswalks,
  deleteCrosswalks,
  createCrosswalk,
  showCrosswalk,
  fetchCdes,
  associateCdes,
  fetchDomains,
  associateDomains,
  fetchDataSources,
  associateDataSources,
  fetchBusinessTerms,
  associateBusinessTerms,
};

export default referenceSourcesExploreApi;
